import "./Contact.css";

export const Contact = () => {
    return (
        <div className="contact-container">
            <h1>Contact</h1>
            <p>
                For further information or if you have any questions regarding
                your archive material please contact Jonathan:
                <br />
                <br /> Owner: Jonathan S Harris Cowley
                <br /> Phone: <a href="tel:07722 050539">07722 050539</a>
                <br /> Email:{" "}
                <a href="mailto:mail@audioreunited.co.uk">
                    mail@audioreunited.co.uk
                </a>
                <br /> Address: 9 Oakdale Road, Epsom, Surrey, KT19 9XD
            </p>
        </div>
    );
};
